var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-list",style:(("cursor: " + _vm.cursor + ";")),on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('img',{style:(("cursor: " + _vm.cursor + ";")),attrs:{"src":_vm.img,"alt":"text","height":_vm.size}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c569602","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/ui/p-item-list.vue
// module id = 3306
// module chunks = 46